export default {
    data() {
        return {
            valid: {
                volume: false,
                card_type: false
            },
            success: {
                volume: false,
                card_type: false
            },
            error: {
                volume: "",
                card_type: ""
            },
            errorMessages: {
                volumeRequired: {
                    el: "",
                    en: "Volume is required",
                    it: ""
                },
                volumeMinWillBe50: {
                    el: "",
                    en: "Minimum is 50",
                    it: ""
                },
                cardTypeRequired: {
                    el: "",
                    en: "Card Type is required",
                    it: ""
                }
            }
        };
    },

    computed: {
        formValid() {
            return(
                this.valid.volume && 
                this.valid.card_type 
            )  
        }
    },

    methods: {
        validateVolume() {
            if (!this.loyaltyCard.volume) {
                this.error.volume = this.errorMessages.volumeRequired[
                    this.lang
                ];
            }else if(this.loyaltyCard.volume && this.loyaltyCard.volume < 50){
                this.error.volume = this.errorMessages.volumeMinWillBe50[this.lang];
            } else {
                this.error.volume = "";
            }
        },

        validateCardType() {
            if (!this.loyaltyCard.card_type) {
                this.error.card_type = this.errorMessages.cardTypeRequired[
                    this.lang
                ];
            } else {
                this.error.card_type = "";
            }
        }
    },

    watch: {
        ["loyaltyCard.volume"]: {
            immediate: true,
            handler(val) {
                if(val && val >= 50){
                    this.valid.volume = true;
                    this.success.volume = true;
                }else{
                    this.valid.volume = false;
                    this.success.volume = false;
                }
            }
        },

        ["loyaltyCard.card_type"]: {
            immediate: true,
            handler(val) {
                this.valid.card_type = !!val;
                this.success.card_type = !!val;
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    volume: false,
                    card_type: false
                };

                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        volume: "",
                        card_type: ""
                    };

                    this.setResetValidation(false);
                }
            }
        }
    }
};
